const React = require('react');
const map = require('mn-utils/map');

const {INTERVALS, INTERVAL_CUSTOM} = require('../../../../constants/intervals');
const {mobile$} = require("../../../../../../../emitters/mobile");
const withState = require("../../../../../../../utils/withState");
const TimeIntervalBtn = require('../../../IntervalFilterConstructor/components/TimeIntervalBtn');
const {AdminSelect} = require("../../../../../FormInputs");

const IntervalBtn = require('../IntervalBtn');

module.exports = withState(() => {
  return ({mobile}, {data, onChange, disabled}) => {
    return (
      <>
        {mobile
          ? (
            <div className="w mt-10 mb-18">
              <AdminSelect
                className="(bcA)>.MuiInputBase-root (pb12)>.MuiSelect-root (st50%|c717070)>.arrow-icon"
                propValue="id"
                propName="name"
                items={INTERVALS}
                value={data.interval}
                onChange={(name, interval) => (
                  onChange && onChange({...data, interval})
                )}
              />
            </div>
          ) : (
            <div className="layoutRow">
              {map(INTERVALS, (item) => item.id !== INTERVAL_CUSTOM
                ? (
                  <TimeIntervalBtn
                    key={item.id}
                    item={item}
                    data={data}
                    btnComponent={IntervalBtn}
                    onChange={onChange}
                    disabled={disabled}
                  />
                ) : false
              )}
            </div>
          )
        }
        <div>
          <TimeIntervalBtn
            item={{id: INTERVAL_CUSTOM}}
            data={data}
            btnComponent={IntervalBtn}
            onChange={onChange}
            disabled={disabled}
            isCustom
          />
        </div>
      </>
    );
  }
}, {
  mobile: mobile$
})

